import { Component, Input, Renderer2, Inject, NgModule } from '@angular/core';
import { DOCUMENT, BrowserModule } from '@angular/platform-browser';

var NgxTawkComponent = /** @class */ (function () {
    function NgxTawkComponent(_renderer, _document) {
        this._renderer = _renderer;
        this._document = _document;
    }
    NgxTawkComponent.prototype.ngOnInit = function () {
        var s = this._renderer.createElement('script');
        s.text = "var Tawk_API = Tawk_API || {}, Tawk_LoadStart = new Date();\n    (function () {\n      var s1 = document.createElement(\"script\"), s0 = document.getElementsByTagName(\"script\")[0];\n      s1.async = true;\n      s1.src = 'https://embed.tawk.to/" + this.id + "/default';\n      s1.charset = 'UTF-8';\n      s1.setAttribute('crossorigin', '*');\n      s0.parentNode.insertBefore(s1, s0);\n    })();";
        this._renderer.appendChild(this._document.body, s);
    };
    return NgxTawkComponent;
}());
NgxTawkComponent.decorators = [
    { type: Component, args: [{
                selector: 'ngx-tawk',
                template: ''
            },] },
];
NgxTawkComponent.ctorParameters = function () { return [
    { type: Renderer2, },
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] },] },
]; };
NgxTawkComponent.propDecorators = {
    "id": [{ type: Input },],
};
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
AppModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    NgxTawkComponent
                ],
                imports: [
                    BrowserModule
                ],
                exports: [NgxTawkComponent],
                providers: [],
                bootstrap: [NgxTawkComponent]
            },] },
];

export { AppModule as NgxTawkModule, NgxTawkComponent };
//# sourceMappingURL=ngx-tawk.js.map
